import dynamic from 'next/dynamic';

const MobileMenuDynamic = dynamic(() => import('./MobileMenu'));

export default MobileMenuDynamic;
